exports.list = {
    path: '/uang_muka',
    name: 'uang_muka', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/uang_muka/List.vue"),
}
exports.show = {
    path: '/uang_muka/show/:no_kk',
    name: 'uang_muka_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/uang_muka/Show.vue"),
}